export class PushNotifSortingModel{
    public beginDate: string;
    public endDate: string;
    public userId: number; 
    public geoId: number;
}


// WEBPACK FOOTER //
// ./src/app/core/models/pushNotifSortingModel.ts